<template>
  <v-container fill-height
               fluid
               grid-list-xl>
    <v-layout justify-center
              wrap>

      <v-flex xs12 md12 lg10>


        <material-card :color="getTitleColorStore"
                       :title="$t('menu_seminar_task_download')"
                       :text="$t('materials_and_docs.subtitle')">
          <ProgressBar :loading="loading" color="deep-purple accent-4" />


          <v-flex xs12>
            <DigitalManuals :loadingFunction="digitalManualsLoading" :storeTitleColor="getTitleColorStore"></DigitalManuals>
            <SeminarDownload :loadingFunction="seminarLoading" :storeTitleColor="getTitleColorStore"></SeminarDownload>
            <AdditionalDocuments :loadingFunction="otherDocumentsLoading" :storeTitleColor="getTitleColorStore"></AdditionalDocuments>
          </v-flex>

        </material-card>

      </v-flex>

    </v-layout>
  </v-container>

</template>
<script>
  import { mapGetters } from 'vuex';
  import SeminarDownload from './components/SeminarDownload.vue'
  import AdditionalDocuments from './components/AdditionalDocuments.vue'
  import DigitalManuals from './components/DigitalManuals.vue'

  export default {
    name: 'Downloads',
    computed: {
      ...mapGetters('app', { getTitleColorStore: 'getTitleColor' }),
      loading() {
        return this.loadingSeminar || this.loadingOtherDocuments || this.loadingDigitalManuals;
      }
    },

    data() {
      return {
        loadingSeminar: false,
        loadingDigitalManuals: false,
        loadingOtherDocuments: false
      }
    },

    methods: {
      seminarLoading(isLoading) {
        this.loadingSeminar = isLoading;
      },

      otherDocumentsLoading(isLoading) {
        this.loadingOtherDocuments = isLoading;
      },

      digitalManualsLoading(isLoading) {
        this.loadingDigitalManuals = isLoading;
      }
    },

    components: {
      SeminarDownload,
      AdditionalDocuments,
      DigitalManuals
    }

  }
</script>
<style type="text/css">
  .v-list__tile--link-border-custom {
    border: 1px solid #eeeeee;
  }
</style>



// WEBPACK FOOTER //
// VueSrc/SeminarTask/Downloads.vue